<template>

  <div class="width-100-p">
    <el-row class="m-0">
      <!-- Abatement Usage -->
      <el-col
        class="p-2"
        :span="
          $vuetify.display.width >= 1520
            ? 24
            : $vuetify.display.width >= 1500 && $vuetify.display.width < 1650
            ? 12
            : $vuetify.display.width >= 1212 && $vuetify.display.width < 1500
            ? 24
            : 24
        "
      >
        <div class="d-flex align-center bg-me-light-blue rounded-4 px-4 height-72 card-a2">
          <div class="width-50 height-50 mr-4 d-flex justify-center align-center">
            <svg class="width-50 height-50 svg-vertical-centered">
              <use href="@/assets/svg/icon-sprite.svg#usage-icon"></use>
            </svg>
          </div>
          <div class="flex-grow-1">
            <span class="moderat-meGreen mb-1">{{ abatementData.abatement_usage.title }}</span>
            <p class="moderat-meGreen-bold-16 mb-0">{{ abatementData.abatement_usage.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
          </div>
        </div>
      </el-col>

      <!-- Emission Intensity -->
      <el-col
        class="p-2"
        :span="
          $vuetify.display.width >= 1520
            ? 24
            : $vuetify.display.width >= 1500 && $vuetify.display.width < 1650
            ? 12
            : $vuetify.display.width >= 1212 && $vuetify.display.width < 1500
            ? 24
            : 24
        "
      >
        <div class="d-flex align-center bg-me-light-blue rounded-4 px-4 height-72 card-a2">
          <div class="width-50 height-50 mr-4 d-flex justify-center align-center">
            <svg class="width-50 height-50 svg-vertical-centered">
              <use href="@/assets/svg/icon-sprite.svg#emission-intensity-icon"></use>
            </svg>
          </div>
          <div class="flex-grow-1">
            <span class="moderat-meGreen mb-1">{{ abatementData.intensity.title }}</span>
            <p class="moderat-meGreen-bold-16 mb-0">{{ abatementData.intensity.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
          </div>
        </div>
      </el-col>

      <!-- Total Abatement -->
      <el-col
        class="p-2"
        :span="
          $vuetify.display.width >= 1520
            ? 24
            : $vuetify.display.width >= 1500 && $vuetify.display.width < 1650
            ? 12
            : $vuetify.display.width >= 1212 && $vuetify.display.width < 1500
            ? 24
            : 24
        "
      >
        <div class="d-flex align-center bg-me-light-blue rounded-4 px-4 height-72 card-a2">
          <div class="width-50 height-50 mr-4 d-flex justify-center align-center">
            <svg class="width-50 height-50 svg-vertical-centered">
              <use href="@/assets/svg/icon-sprite.svg#total-abatement-icon"></use>
            </svg>
          </div>
          <div class="flex-grow-1">
            <span class="moderat-meGreen mb-1">{{ abatementData.total_abatement.title }}</span>
            <p class="moderat-meGreen-bold-16 mb-0">{{ abatementData.total_abatement.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
          </div>
        </div>
      </el-col>

      <!-- Abatement per MWh -->
      <el-col
        class="p-2"
        :span="
          $vuetify.display.width >= 1520
            ? 24
            : $vuetify.display.width >= 1500 && $vuetify.display.width < 1650
            ? 12
            : $vuetify.display.width >= 1212 && $vuetify.display.width < 1500
            ? 24
            : 24
        "
      >
        <div class="d-flex align-center bg-me-light-blue rounded-4 px-4 height-72 card-a2">
          <div class="width-50 height-50 mr-4 d-flex justify-center align-center">
            <svg class="width-50 height-50 svg-vertical-centered">
              <use href="@/assets/svg/icon-sprite.svg#abatement-per-mwh-icon"></use>
            </svg>
          </div>
          <div class="flex-grow-1">
            <span class="moderat-meGreen mb-1">{{ abatementData.abatement_per.title }}</span>
            <p class="moderat-meGreen-bold-16 mb-0">{{ abatementData.abatement_per.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>


</template>

<script>
export default {
  props: {
    dataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
  },
  components: {
    // ShowDetail,
  },
  data() {
    return {
      show: true,
      abatementData: {
        intensity: { title: "", value: "0" },
        total_abatement: { title: "", value: "0" },
        abatement_per: { title: "", value: "0" },
        abatement_usage: { title: "", value: "0" },
      },
    };
  },
  watch: {
    dataProp: {
      handler: function (newValue) {
        this.abatementData.total_abatement = newValue.abatement;
        this.abatementData.abatement_per = newValue.abatement_per_MWh;
        this.abatementData.abatement_usage = newValue.usage_mwh;
        this.abatementData.intensity = newValue.intensity;
      },
      deep: true,
    },
  },
  methods: {},
};
</script>

<style scoped>
.svg-vertical-centered {
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>
